"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZScriptBlocks = exports.ZDualBlockConfig = exports.ZUniformBlockConfig = exports.ZAlignmentEnum = exports.ALL_BLOCK_TYPES = exports.ZBlockEnum = exports.ZDualFormatBlockEnum = exports.DUAL_FORMAT_BLOCK_TYPES = exports.ZUniformBlockEnum = exports.UNIFORM_BLOCK_TYPES = void 0;
const zod_1 = require("zod");
// these block types don't vary within a script format
exports.UNIFORM_BLOCK_TYPES = [
    'general',
    'new_act',
    'end_of_act',
    'action',
    'sceneHeading',
    'transition',
    'slug',
    'bracket',
    'dual_dialogue',
    'dual_dialogue_column',
];
exports.ZUniformBlockEnum = zod_1.z.enum(exports.UNIFORM_BLOCK_TYPES);
// these blocks have a different format when they're in a dual dialogue
exports.DUAL_FORMAT_BLOCK_TYPES = [
    'dialogue',
    'character',
    'parenthetical',
];
exports.ZDualFormatBlockEnum = zod_1.z.enum(exports.DUAL_FORMAT_BLOCK_TYPES);
exports.ZBlockEnum = zod_1.z.union([exports.ZUniformBlockEnum, exports.ZDualFormatBlockEnum]);
exports.ALL_BLOCK_TYPES = [
    ...exports.DUAL_FORMAT_BLOCK_TYPES,
    ...exports.UNIFORM_BLOCK_TYPES,
];
exports.ZAlignmentEnum = zod_1.z.enum(['left', 'right', 'center']);
exports.ZUniformBlockConfig = zod_1.z
    .object({
    marginLeft: zod_1.z.number().int().nonnegative(),
    width: zod_1.z.number().int().nonnegative(),
    alignment: exports.ZAlignmentEnum,
    lineHeight: zod_1.z.number().positive(),
    blockTopMargin: zod_1.z.number(),
    bold: zod_1.z.boolean(),
    uppercase: zod_1.z.boolean(),
    italic: zod_1.z.boolean(),
    underline: zod_1.z.boolean(),
    color: zod_1.z.string().optional(),
})
    .strict();
exports.ZDualBlockConfig = exports.ZUniformBlockConfig.extend({
    dualDialogOverrides: exports.ZUniformBlockConfig,
});
// A block configuration provides a UniformBlockConfig for each UniformBlockType and a DualFormatConfig for each DualFormatBlockType
exports.ZScriptBlocks = zod_1.z
    .object({
    general: exports.ZUniformBlockConfig,
    new_act: exports.ZUniformBlockConfig,
    end_of_act: exports.ZUniformBlockConfig,
    action: exports.ZUniformBlockConfig,
    sceneHeading: exports.ZUniformBlockConfig,
    transition: exports.ZUniformBlockConfig,
    slug: exports.ZUniformBlockConfig,
    bracket: exports.ZUniformBlockConfig,
    dual_dialogue: exports.ZUniformBlockConfig,
    dual_dialogue_column: exports.ZUniformBlockConfig,
    dialogue: exports.ZDualBlockConfig,
    character: exports.ZDualBlockConfig,
    parenthetical: exports.ZDualBlockConfig,
})
    .strict();
